import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { PullToRefresh } from "@/components/atomic-crm/layout/PullToRefresh";
import { RevisorLargoPlazo } from "../datos/RevisorLargoPlazo";
import { GuiaHost } from "../guia/GuiaHost";
import { BuscadorFichas } from "../negocios/BuscadorFichas";
import { VentanaFicha } from "../negocios/VentanaFicha";
import { NavegacionMovil } from "./NavegacionMovil";

/** Layout móvil (< 768 px). Copia adaptada de layout/MobileLayout.tsx de Atomic. */
export const LayoutMovil = ({ children }: { children: ReactNode }) => (
  <>
    <RevisorLargoPlazo />
    <PullToRefresh />
    <ErrorBoundary FallbackComponent={Error}>
      <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
        {children}
      </Suspense>
    </ErrorBoundary>
    <NavegacionMovil />
    <BuscadorFichas />
    <VentanaFicha />
    <GuiaHost />
    <Notification mobileOffset={{ bottom: "72px" }} />
  </>
);
